import { Dispatch } from "redux";

import { patchCartItems } from "api/requests/patchCartItems";
import { CartContext, CartItem } from "custom-types/Cart";
import { CountryCode } from "custom-types/Finder";
import { trackCheckoutEvent } from "utils/trackEvent";

import {
  UPDATE_CART_FAILURE,
  UPDATE_CART_REQUEST,
  UPDATE_CART_SUCCESS,
} from "../reducers/cart";

export const updateCart = (
  dispatch: Dispatch,
  item: CartItem,
  trackingKeyword: string,
  sessionId: string,
  janeCheckoutEnabled: boolean,
  calculateTax = false,
  cartContext: CartContext | null = null,
  domainCountryCode: CountryCode,
  isInStore?: boolean
) => {
  dispatch({
    type: UPDATE_CART_REQUEST,
  });

  return patchCartItems({
    calculateTax: calculateTax,
    cartContext: cartContext,
    cartItem: item,
    domainCountryCode,
    sessionId: sessionId,
    ...(isInStore && { inStoreCart: true }),
  })
    .then((cart) => {
      trackCheckoutEvent("Click", trackingKeyword, {
        cartItem: item,
        category: "Checkout Page Cart",
      });
      dispatch({
        cart,
        type: UPDATE_CART_SUCCESS,
      });
    })
    .catch((error: string) => {
      trackCheckoutEvent("Click", "Error", {
        bagId: sessionId,
        category: "Add to Bag",
        errorMessage: error || "Could not update cart",
        janeCheckoutEnabled,
      });
      dispatch({
        error,
        type: UPDATE_CART_FAILURE,
      });
    });
};
